import { Warning } from '@styled-icons/ionicons-outline/Warning';

import * as S from './styles';

export type InfoMessageTypes = {
  variant: 'warning';
  text: string;
};

const InfoMessage = ({ variant, text }: InfoMessageTypes) => {
  const variantMapper = {
    warning: <Warning size={16} aria-label="Warning icon" />,
  };

  return (
    <S.Wrapper variant={variant}>
      <S.Icon>{variantMapper[variant]}</S.Icon>

      <p>{text}</p>
    </S.Wrapper>
  );
};

export default InfoMessage;
